/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

export const PageHeader = ({ t }) => {
  return (
    <div className="kt-subheader kt-grid__item" id="kt_subheader">
      <div className="kt-container kt-container--fluid">
        <div className="kt-subheader__main">
          <h3 className="kt-subheader__title">{t("Paramètres")}</h3>
          <span className="kt-subheader__separator kt-hidden" />
          <div className="kt-subheader__breadcrumbs">
            <a href="#" className="kt-subheader__breadcrumbs-home">
              <i className="flaticon2-shelter" />
            </a>
            <span className="kt-subheader__breadcrumbs-separator" />
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              className="kt-subheader__breadcrumbs-link"
            >
              {t("Coefficient")}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
